import React, {useContext} from "react";
import moment from "moment-timezone";
import LeadsByCategoryOverview from "./TablesAndGraphs/LeadsByCategoryOverview.jsx";
import LeadsByDateCard from "./TablesAndGraphs/LeadsByDateCard.jsx";
import {useTranslation} from "react-i18next";
import LeadDashboardLayout from "./Layout/LeadDashboardLayout.jsx";
import {FilterContext} from "../../../components/filters/DashboardFilterContextProvider.jsx";


export default function MainLeadOverview({project}) {

    let {t} = useTranslation();

    let {since, until} = useContext(FilterContext);

    // noinspection JSValidateTypes
    return <LeadDashboardLayout
        title={t('route.performance-summary')}
        hideSourceFilter={true}
        hideCampaignFilter={true}
    >
        {/* Leads TODAY */}
        <LeadsByDateCard
            since={moment()}
            until={moment()}
            title={t('leads.leads-today')}
            project={project}
        />

        {/* Leads YESTERDAY */}
        <LeadsByDateCard
            since={moment().subtract(1, 'day')}
            until={moment().subtract(1, 'day')}
            title={t('leads.leads-yesterday')}
            project={project}
        />

        {/* Leads LAST X (28,30,31) days */}
        <LeadsByDateCard
            since={moment().subtract(1, 'month')}
            until={moment()}
            title={
                t(
                    'leads.leads-last-x-days',
                    {
                        count: Math.abs(
                            (moment().subtract(1, 'month'))
                                .diff(moment(), 'days')
                        )
                    }
                )
            }
            project={project}
        />

        <LeadsByDateCard
            since={since}
            until={until}
            title={t('leads.leads-by-date-range')}
            project={project}
        />

        {/* # - - - # */}

        <LeadsByCategoryOverview
            since={since}
            until={until}
            project={project}
        />
    </LeadDashboardLayout>;
}
